module.exports = __webpack_public_path__ + "dist/assets/img/bige-icon-check.930af148.svg";